import React, { useEffect, useState } from 'react';
import {
  Wrapper,
  Channel,
  Box,
  Day,
  Preview,
  Text,
  Summary,
  SummaryTitle,
  SummaryDescription,
  TextDescription,
  Line,
  TextHigh
} from './styled';
import { PrintModel } from '@app/src/views/StepThree/publicationConfirmation/models';
import { PreviewPrint } from '@app/src/common/PreviewPrint';

interface Props {
  detail: PrintModel;
}

export const PrintDetail: React.FC<Props> = ({ detail }) => {
  const PUBLICATION: string = 'Publicación';
  const PUBLICATIONS: string = 'Publicaciones';
  const numberPublications: number = detail.dates.length;
  const textPublications: string = numberPublications > 1 ? PUBLICATIONS : PUBLICATION;
  const [settings, setSettings] = useState({
    bold: false,
    titleCenter: false,
    highlight: false,
    starCount: null,
    header: '',
    vignette: false,
    vignetteValue: ''
  });

  useEffect(() => {
    if (detail.extracharges && detail.extracharges.length > 0) {
      let obj = {};
      detail.extracharges.map((item) => {
        obj[item.style] = item.styleValue;
        if (item.alias === 'vineta') {
          obj['vignetteValue'] = item.detail.labelName;
        }
        if (item.alias === 'fotovineta') {
          obj['imageDefault'] = item.detail.photoPreviewUrl;
          obj['isShowPhotoUploader'] = true;
        }
      });
      setSettings({
        ...settings,
        ...obj
      })
    }
  }, []);

  const formatPrice = (price) => price.toFixed(2);

  return (
    <Wrapper>
      <Channel>Clasificados {detail.channel} - <Day>{detail.day}</Day></Channel>
      <Box>
        <Preview>
          <Text>Vista previa de la publicación</Text>
          <PreviewPrint
            heightPhoto="114px"
            title={detail.title}
            words={detail.text}
            {...settings}
          />
        </Preview>
        <Summary>
          <TextHigh>Resumen</TextHigh>
          <SummaryTitle>{numberPublications} {textPublications}</SummaryTitle>
          {detail.dates.map((date, index) => (
            <SummaryDescription key={index}>
              <TextDescription>{date}</TextDescription>
              {
                detail && detail.unitPrice ?
                  <TextDescription>S/ {formatPrice(detail.unitPrice)}</TextDescription> : null
              }
            </SummaryDescription>
          ))}
          {
            detail.extracharges &&
            <SummaryTitle>Extracargos</SummaryTitle>
          }
          {
            detail.extracharges && detail.extracharges.map((extracharge, index) => (
              <SummaryDescription key={index}>
                <TextDescription>{extracharge.name} ({extracharge.quantity})</TextDescription>
                { (extracharge && extracharge.price) ? <TextDescription>S/ {formatPrice(extracharge.price)}</TextDescription> : null}
              </SummaryDescription>
            ))
          }
          {
            (detail && detail.subTotal) ?
              <React.Fragment>
                <Line />
                <SummaryDescription>
                  <TextDescription isBold>Sub Total</TextDescription>
                  <TextDescription isBold>S/ {formatPrice(detail.subTotal)}</TextDescription>
                </SummaryDescription>
              </React.Fragment>
              :
              null
          }
        </Summary>
      </Box>
    </Wrapper>
  );
};

PrintDetail.displayName = 'PrintDetail';
